import { Contatto } from "../types";

export const hasText = (value?: string | null) => !!value && value.trim().length > 0;

export const isLeadDataComplete = (c: Contatto) => {
  const baseReady =
    hasText(c.associato) &&
    hasText(c.servizio_proposto) &&
    hasText(c.esito_contatto) &&
    hasText(c.analisi_lead) &&
    (c.numero_contatti ?? 0) > 0 &&
    !!c.data_ultimo_contatto;

  if (c.tipo === "contatto") {
    return (
      baseReady &&
      hasText(c.nome) &&
      hasText(c.cognome) &&
      hasText(c.azienda) &&
      hasText(c.settore) &&
      hasText(c.indirizzo)
    );
  }

  if (c.tipo === "small-lead") {
    return (
      baseReady &&
      hasText(c.nome) &&
      hasText(c.settore) &&
      hasText(c.indirizzo) &&
      hasText(c.telefono) &&
      hasText(c.email)
    );
  }

  return (
    baseReady &&
    hasText(c.azienda) &&
    hasText(c.nome) &&
    hasText(c.cognome) &&
    hasText(c.settore) &&
    hasText(c.indirizzo) &&
    hasText(c.telefono)
  );
};
